export const skillBasedStyles: { [key: string]: string } = {
  Adaptability: "bg-skillColor-adaptability border-skillColor-adaptabilityBorder",
  Communication: "bg-skillColor-communication border-skillColor-communicationBorder",
  ["Critical Thinking"]: "bg-skillColor-criticalThinking border-skillColor-criticalThinkingBorder",
  Collaboration: "bg-skillColor-collaboration border-skillColor-collaborationBorder",
  Empathy: "bg-skillColor-empathy border-skillColor-empathyBorder",
  ["Learner's Mindset"]: "bg-skillColor-learnersMindset border-skillColor-learnersMindsetBorder",
  ["Personal Responsibility"]: "bg-skillColor-personalResponsibility border-skillColor-personalResponsibilityBorder",
};

export const indexBasedColorStyles = [
  "bg-skillColor-adaptability border-skillColor-adaptabilityBorder",
  "bg-skillColor-communication border-skillColor-communicationBorder",
  "bg-skillColor-criticalThinking border-skillColor-criticalThinkingBorder",
  "bg-skillColor-collaboration border-skillColor-collaborationBorder",
  "bg-skillColor-empathy border-skillColor-empathyBorder",
  "bg-skillColor-learnersMindset border-skillColor-learnersMindsetBorder",
  "bg-skillColor-personalResponsibility border-skillColor-personalResponsibilityBorder",
];